import { EditOutlined, DeleteOutlined, DownOutlined } from '@ant-design/icons';
import { Dropdown, Menu, Button, Space } from 'antd';
import { useTranslation } from 'react-i18next';
import { type InsuranceModuleSpecsFragment } from '../../../../api/fragments/InsuranceModuleSpecs';
import { type PermissionValues } from '../../../../utilities/hasPermissions';
import useDeleteModule from '../useDeleteModule';
import { useUpdateInsuranceModuleDrawer } from './InsuranceModuleUpdateDrawer';

export type InsuranceModuleActionsProps = {
    module: InsuranceModuleSpecsFragment;
    permissions: Pick<PermissionValues, 'hasDeletePermission' | 'hasUpdatePermission'>;
};

const InsuranceModuleActions = ({ module, permissions }: InsuranceModuleActionsProps) => {
    const { t } = useTranslation(['insuranceModuleDetails', 'moduleDetails']);
    const deleteModule = useDeleteModule(module.id);

    const updateInsuranceModuleDrawer = useUpdateInsuranceModuleDrawer(module);
    const { hasUpdatePermission, hasDeletePermission } = permissions;

    const items = [
        hasUpdatePermission && {
            label: t('insuranceModuleDetails:mainActionButtons.updateSpecs'),
            key: 'updateSpecs',
            icon: <EditOutlined />,
            onClick: updateInsuranceModuleDrawer.open,
        },
        hasDeletePermission && {
            label: t('insuranceModuleDetails:mainActionButtons.delete'),
            key: 'delete',
            icon: <DeleteOutlined />,
            onClick: deleteModule,
            danger: true,
        },
    ].filter(Boolean);

    if (!items.length) {
        return null;
    }

    return (
        <>
            <Dropdown overlay={<Menu items={items} />}>
                <Button type="primary">
                    <Space>
                        <span>{t('insuranceModuleDetails:mainActionButtons.actions')}</span>
                        <DownOutlined />
                    </Space>
                </Button>
            </Dropdown>
            {updateInsuranceModuleDrawer.render()}
        </>
    );
};

export default InsuranceModuleActions;
